import { news } from '@/mocks/news';
import { videos } from '@/mocks/videos';
import { specials } from '@/mocks/specials';
import type { NewsItem, VideoItem, SpecialItem } from '@/types/content';

export const getNewsById = (id: string): NewsItem | undefined =>
  (news as NewsItem[]).find((item) => item.id === id);

export const getVideoById = (id: string): VideoItem | undefined =>
  (videos as VideoItem[]).find((item) => item.id === id);

export const getSpecialById = (id: string): SpecialItem | undefined =>
  (specials as SpecialItem[]).find((item) => item.id === id);

export const getNewsByCategory = (category: string): NewsItem[] =>
  (news as NewsItem[]).filter((item) => item.category === category);

export const getRelatedNews = (item: NewsItem, limit = 4): NewsItem[] => {
  const pool = (news as NewsItem[]).filter((n) => n.id !== item.id);
  const scored = pool
    .map((n) => {
      let score = 0;
      if (n.category === item.category) score += 3;
      score += n.tags.filter((t) => item.tags.includes(t)).length * 2;
      return { n, score };
    })
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((s) => s.n);
};

export const getRelatedVideos = (item: VideoItem, limit = 4): VideoItem[] => {
  const pool = (videos as VideoItem[]).filter((v) => v.id !== item.id);
  const scored = pool
    .map((v) => {
      let score = 0;
      if (v.type === item.type) score += 3;
      if (v.category === item.category) score += 2;
      score += v.tags.filter((t) => item.tags.includes(t)).length * 2;
      return { v, score };
    })
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((s) => s.v);
};

export const searchNews = (keyword: string): NewsItem[] => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return (news as NewsItem[]).filter(
    (item) =>
      item.title.toLowerCase().includes(kw) ||
      item.summary.toLowerCase().includes(kw) ||
      item.categoryName.toLowerCase().includes(kw) ||
      item.tags.some((t) => t.toLowerCase().includes(kw))
  );
};

export const searchVideos = (keyword: string): VideoItem[] => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return (videos as VideoItem[]).filter(
    (item) =>
      item.title.toLowerCase().includes(kw) ||
      item.description.toLowerCase().includes(kw) ||
      item.typeName.toLowerCase().includes(kw) ||
      item.tags.some((t) => t.toLowerCase().includes(kw))
  );
};

export const formatViews = (views: number): string => {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return `${views}`;
};

export const formatDate = (date: string): string => {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return date;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const videoTypeOptions = [
  { key: 'all', name: '全部' },
  { key: 'film', name: '影视剧' },
  { key: 'variety', name: '综艺' },
  { key: 'short', name: '短视频' },
];

export { news, videos, specials };